import { Wrapper } from 'AppReact';
import styled, {css} from 'styled-components';



const template = styled.div`
  ${({ displayState }) => css`
    align-items: ${displayState?.alignDirection ?? 'center'};
    display: flex; height: 100%; 
    flex-direction: column; 
    justify-content: center;
  `}
`
export default Wrapper(template);